import { render, staticRenderFns } from "./DevelopmentCard.vue?vue&type=template&id=144a540c&scoped=true"
import script from "./DevelopmentCard.vue?vue&type=script&lang=ts"
export * from "./DevelopmentCard.vue?vue&type=script&lang=ts"
import style0 from "./DevelopmentCard.vue?vue&type=style&index=0&id=144a540c&prod&lang=scss"
import style1 from "./DevelopmentCard.vue?vue&type=style&index=1&id=144a540c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "144a540c",
  null
  
)

export default component.exports